import mapContext from '../../../contexts/map-context';
import { ActionTypes } from '../../../contexts/reducers/map-reducer';

export const handleSearchThisArea = () => {
  const { bounds } = mapContext.useMapState();
  const dispatch = mapContext.useMapDispatch();

  return () => {
    dispatch({
      type: ActionTypes.setSearchText,
      payload: '',
    });
    dispatch({
      type: ActionTypes.setNorthEastPosition,
      payload: bounds.ne,
    });
    dispatch({
      type: ActionTypes.setSouthWestPosition,
      payload: bounds.sw,
    });
    dispatch({
      type: ActionTypes.resetGeolocationSearch,
      payload: null,
    });
    dispatch({
      type: ActionTypes.setQuery,
      payload: '',
    });
    dispatch({
      type: ActionTypes.setPlaceId,
      payload: '',
    });
    dispatch({
      type: ActionTypes.setSelectedDealerId,
      payload: null,
    });
    dispatch({
      type: ActionTypes.setDealerReviews,
      payload: [],
    });
    dispatch({
      type: ActionTypes.setSearchInThisAreaVisible,
      payload: false,
    });
    dispatch({
      type: ActionTypes.setLastSubmittedSearch,
      payload: null,
    });
  };
};
